import React from "react";

export const Portfolio = () => (
    <div className="Portfolio">
      <main>
       <h1>Portfolio</h1>
      </main>
    </div>
  );